import { render, staticRenderFns } from "./breeds.vue?vue&type=template&id=68beadab&scoped=true&"
import script from "./breeds.vue?vue&type=script&lang=js&"
export * from "./breeds.vue?vue&type=script&lang=js&"
import style0 from "./breeds.vue?vue&type=style&index=0&id=68beadab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68beadab",
  null
  
)

export default component.exports